import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import useCheckWorklistContainer from "../../hooks/useCheckWorklistContainer";
import useMedia, { MediaSizes } from "../../hooks/useMedia";

const arrowPositionStyle = {
  bottom: {
    top: 0,
    transform: "translateY(-100%)",
  },
  top: {
    top: "100%",
    transform: "rotate(180deg)",
  },
  "top-right": { top: "100%", right: -40, transform: "rotate(180deg)" },
  "top-left": { top: "100%", left: 5, transform: "rotate(180deg)" },
  "bottom-left": { top: -15, left: 5 },
  "bottom-right": { top: -9, right: -40 },
  right: {
    top: "calc(50% - 8px)",
    left: -15,
    transform: "rotate(270deg)",
  },
  left: {
    top: "calc(50% - 8px)",
    right: -15,
    transform: "rotate(-270deg)",
  },
};

const Tooltip = ({
  content,
  isSticky = false,
  position = "bottom",
  tight = false,
  children,
  isDisabled = false,
  className,
  bubbleClassName = "",
}) => {
  const [isActive, setIsActive] = useState(false);
  const isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  const isWorkList = useCheckWorklistContainer();

  const handleMouseOver = () => {
    if (!isActive) {
      setIsActive(true);
    }
  };

  const handleMouseOut = () => {
    if (isActive) {
      setIsActive(false);
    }
  };

  const isOpen = (isSticky || isActive) && !isDisabled;
  const isMobileLayout = isMobile;

  return (
    <div
      className={classnames("relative", className)}
      onMouseEnter={handleMouseOver}
      onFocus={handleMouseOver}
      onMouseLeave={handleMouseOut}
      onBlur={handleMouseOut}
      role="tooltip"
    >
      {children}
      <div
        className={classnames(`cursor-pointer tooltip tooltip-${position} z-[9999]`, {
          block: isOpen,
          hidden: !isOpen || isMobileLayout,
        })}
      >
        <div
          className={classnames(
            "tooltip-box h-full bg-gray-900 border border-gray-800 text-white text-sm rounded inset-x-auto top-full w-max",
            {
              "py-1 px-4": !tight,
              [bubbleClassName]: !!bubbleClassName,
            }
          )}
        >
          {typeof content === "string" ? content : content}
        </div>
        <div className="absolute w-full" style={arrowPositionStyle[position]}>
          <svg
            className="mx-auto h-4 text-gray-800 stroke-gray-800"
            viewBox="0 0 100 100"
          >
            <polygon fill="currentColor" points="50 15, 100 100, 0 100" />
          </svg>
        </div>
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  /** prevents tooltip from rendering despite hover/active/sticky */
  isDisabled: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  position: PropTypes.oneOf([
    "bottom",
    "bottom-left",
    "bottom-right",
    "top",
    "top-left",
    "top-right",
    "left",
    "right",
  ]),
  className: PropTypes.string,
  isSticky: PropTypes.bool,
  tight: PropTypes.bool,
  children: PropTypes.node.isRequired,
  bubbleClassName: PropTypes.string,
};

export default Tooltip;
